


export function getPlanLevel(plan:string) {

  let planLevel:string = plan;

  // for example, the lifefime-basic plan is considered have the basic level
  // the lifetime-pro level is considered to have the Pro level
  if (planLevel.startsWith("lifetime-")) {
    planLevel = planLevel.replace("lifetime-", "");
  }

  if (planLevel?.includes("basic")) {
    planLevel = "basic";
  }

  if (planLevel?.includes("pro")) {
    planLevel = "pro";
  }

  return planLevel;

}
